import { BaseEntity } from "yt-ng-framework";

export class CompanyTelefonView extends BaseEntity{
    constructor(){
        super();
    }

    Glavni:boolean = null;
    VrstaTelefona:string = null;
    Broj:string = null;
    Lokal:string = null;
    Svojina:string = null;
    Opis:string = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Glavni=input.Glavni;
        this.VrstaTelefona=input.VrstaTelefona;
        this.Broj=input.Broj;
        this.Lokal=input.Lokal;
        this.Svojina=input.Svojina;
        this.Opis=input.Opis;
        return this;
    }

    Serialize(input:CompanyTelefonView){
        return input;
    }
}